import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import HomePage from './pages/HomePage';
import reportWebVitals from './reportWebVitals';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import OyunTerapisi from './pages/OyunTerapisi';
import MoxoTesti from './pages/MoxoTesti';
import OgrenciDanismanligi from './pages/OgrenciDanismanligi';
import BireyselYetiskinPsikoterapisi from './pages/BireyselYetiskinPsikoterapisi';
import ServicesPage from './pages/ServicesPage';
import NotFoundPage from './pages/NotFoundPage';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<App />}>
            <Route index element={<HomePage />} />
            <Route path="hakkimda" element={<AboutPage />} />
            <Route path="iletisim" element={<ContactPage />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="blog/:slug" element={<BlogDetailPage />} />
            <Route path="calisma-alanlarim" element={<ServicesPage />} />
            <Route path="bireysel-yetiskin-psikoterapisi" element={<BireyselYetiskinPsikoterapisi />} />
            <Route path="oyun-terapisi" element={<OyunTerapisi />} />
            <Route path="moxo-testi" element={<MoxoTesti />} />
            <Route path="ogrenci-danismanligi" element={<OgrenciDanismanligi />} />

            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();